module.exports = __webpack_public_path__ + "static/media/PaulAndClaire-2.0ec76a84.png";